import React, { useState, CSSProperties } from 'react'
import Gallery, { ReactImageGalleryItem } from 'react-image-gallery'
import './ImageGallery.css'

interface CompProps {
  imageUrls: string[]
}
const ImageGallery: React.FC<CompProps> = ({ imageUrls = [] }) => {
  const images = imageUrls.map((photo) => ({
    original: photo,
    thumbnail: photo
  }))

  const [isFullScreen, setIsFullScreen] = useState(false)

  const renderItem = (item: ReactImageGalleryItem): React.ReactNode => {
    const regularStyle: CSSProperties = { objectFit: 'cover', width: '100%', height: '500px' }
    const fullScreenStyle: CSSProperties = { height: '100%' }
    return (
      <div style={{ width: '100%', marginRight: 'auto' }}>
        <img
          style={isFullScreen ? fullScreenStyle : regularStyle}
          className='image-gallery-image'
          src={item.original}
          alt={item.originalAlt}
          srcSet={item.srcSet}
          sizes={item.sizes}
          title={item.originalTitle}
        />
      </div>
    )
  }

  if (imageUrls.length > 0) {
    return (
      <Gallery
        lazyLoad
        thumbnailPosition='right'
        renderItem={renderItem}
        showPlayButton={false}
        items={images}
        onScreenChange={(isFull) => {
          setIsFullScreen((isFull as unknown) as boolean)
        }}
      />
    )
  }
  return null
}

export default ImageGallery
